import { render, staticRenderFns } from "./AlbumStyleZone.vue?vue&type=template&id=f8b90888&scoped=true&"
import script from "./AlbumStyleZone.vue?vue&type=script&lang=js&"
export * from "./AlbumStyleZone.vue?vue&type=script&lang=js&"
import style0 from "./AlbumStyleZone.vue?vue&type=style&index=0&id=f8b90888&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b90888",
  null
  
)

export default component.exports